import { ReportHeader } from "@/components/report-header";
import { EmptyState } from "@/components/ui/empty-state";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ViewSelector } from "@/components/view-selector";
import { SavedViewProvider } from "@/contexts/saved-view-context";
import { usePageTitle } from "@/hooks/use-page-title";
import { useWebpageChannelSelection } from "@/hooks/use-webpage-channel-selection";
import { useWebpageSelection } from "@/hooks/use-webpage-selection";
import { WebpageScorecard } from "./webpage-scorecard";
import { WebpageSelector } from "./webpage-selector";

export default function WebpageExplorer() {
  const pageType = "webpages::explorer";
  const { selectedWebpageUrl } = useWebpageSelection();
  const { selectedChannelId, setSelectedChannelId } =
    useWebpageChannelSelection();

  // Set page title based on selected webpage
  usePageTitle(
    selectedWebpageUrl
      ? `${selectedWebpageUrl} - Web Page Report`
      : "Web Page Report Card",
  );

  return (
    <SavedViewProvider pageType={pageType}>
      <div className="flex flex-col space-y-4">
        <ReportHeader
          title="Web Page Report Card"
          primary={
            <div className="flex flex-wrap gap-2">
              <WebpageSelector />
            </div>
          }
          right={
            selectedWebpageUrl ? (
              <ViewSelector pageType={pageType} />
            ) : undefined
          }
        />

        {!selectedWebpageUrl ? (
          <EmptyState
            title="Select a web page"
            description="Select a web page from the dropdown above to view its report card."
          />
        ) : (
          <Tabs defaultValue="scorecard" className="w-full">
            <div className="flex items-center border-b">
              <TabsList className="border-b-0">
                <TabsTrigger value="scorecard" className="relative">
                  <div className="flex items-center gap-1.5">Scorecard</div>
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="scorecard" className="mt-6">
              <WebpageScorecard
                channelId={selectedChannelId}
                onChannelChange={setSelectedChannelId}
              />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </SavedViewProvider>
  );
}
